export default {"src":"/_next/static/media/wrench_40.892b843a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};